import styled from 'styled-components';
import { themeColor, themeSpacing } from '../../utils';
export default styled.div `
  background-color: ${themeColor('tint', 'level5')};
  padding-top: ${themeSpacing(6)};
`;
//# sourceMappingURL=FooterTop.js.map